<template>
    <div class="container">

    <free-trial 
      v-if="!loading && days_left > 0 && subscriptions.length == 0" 
      :days_left="days_left"></free-trial>

    <div class="card" v-if="loading">
      <div class="card-body">
        <div class="text-center py-2">
          <i class="fas fa-spinner fa-spin"></i>
        </div>
      </div>
    </div>

    <div v-else-if="subscriptions.length == 0">
      <products-list></products-list>
    </div>

    <div v-else>
    <div class="row pb-2">
    <div class="col pr-0"><h5>Subscriptions</h5></div>
    </div>

    <div class="card">
    <div class="card-body pb-0">

          <!-- Desktop -->
          <table class="datatables-basic table d-none d-md-table">
            <thead class="thead-dark">
                <tr>
                  <th class="first-left pl-3" width="25%">Plan</th>
                  <th class="pl-3" width="25%">Websites</th>
                  <th class="pl-3" width="25%">Monthly</th>
                  <th class="first-right pl-3" width="25%">Action</th>
                </tr>
              </thead>
          <tbody>
            <tr v-for="(subscription, index) in subscriptions" :key="index.id">
              <td class="pl-3">{{subscription.product.name}}</td>
              <td class="pl-3">{{subscription.product.sites}}</td>
              <td class="pl-3"><span class="font-weight-bold">{{formattedPrice(subscription.product.price)}}</span></td>           
              <td class="pl-3">
                <a href="#/" title="Change subscription" @click="showModalChangeSubscription(subscription)"><i class="fa-solid fa-pen-to-square mr-4"></i></a>
                <a href="#/" title="Cancel subscription" @click="showModalCancelSubscription(subscription)"><i class="fa-solid fa-ban"></i></a>
                </td>           
            </tr>
          </tbody>
        </table>

        <!-- Mobile -->
        <table class="table d-md-none">
            <thead class="thead-dark">
                <tr>
                  <th class="first-left first-right text-center">Product • Amount</th>
                </tr>
              </thead>
          <tbody>
            <tr class="body" v-for="(subscription, index) in subscriptions" :key="index" @click="openlink(subscription.id)">
  
        <td class="pl-2 text-center">
            <div class="pb-2"><b>{{subscription.product.name}}</b></div>
            <div class="pb-2">Monitor {{subscription.product.sites}} {{subscription.product.sites == 1 ? 'website' : 'websites'}}</div>
            <div class="pb-2">{{formattedPrice(subscription.product.price)}} /month</div>
            <div>
              <a href="#/" title="Change subscription" @click="showModalChangeSubscription(subscription)"><i class="fa-solid fa-pen-to-square mr-4"></i></a>
                <a href="#/" title="Cancel subscription" @click="showModalCancelSubscription(subscription)"><i class="fa-solid fa-ban"></i></a>
            </div>
        </td>

            </tr>
          </tbody>
        </table>

<change-subscription :subscription="selectedSubscription" @subscription-updated="getSubscriptions"></change-subscription>
<cancel-subscription :subscription="selectedSubscription" @subscription-updated="getSubscriptions" ref="CancelSubscription"></cancel-subscription>

  </div>
  </div>
  </div>
  </div>
</template> 

<script>
export default {
  props: ['days_left'],

  data() {
    return {
      subscriptions: [],
      selectedSubscription: {},
      loading: true,
    };
  },

  created() {
    this.getSubscriptions();
  },

  methods: {

    showModalCancelSubscription(subscription) {
      this.selectedSubscription = subscription;
      this.$refs.CancelSubscription.clearContent();
      this.$bvModal.show('bv-modal-cancel-subscription');
    },

    showModalChangeSubscription(subscription) {
      this.selectedSubscription = subscription;
      this.$bvModal.show('bv-modal-change-subscription');
    },

    getSubscriptions() {
     
      axios.get('/subscriptions/get').
      then((response) => {
        this.subscriptions = response.data;
        this.loading = false;
      });
    },

  },
};
</script>

